import { merge, ALLOWED_PLUGINS } from 'util';
Genesys('registerPlugin', 'Database', (Database) => {
  const $$ = Database.data;

  let bSupportNestedObject = false;
  let bDatabaseCleared = false;
  const CLEARED_REJECTION_MESSAGE = 'Messenger is cleared. Please reload the page to reinitialize.';

  $$('database', {});

  /**
  * Validate object's type, and value
  * @param {object} object
  */

  function isObjectAndNotNull(object) {
    return object !== null && typeof object ==='object' && !Array.isArray(object) && Object.keys(object).length;
  }

  /**
  * Checks if the property passed to get/remove command is an array with an index, if yes, return the value of the property
  * Accepted params
  *  - obj
  * - key
  *  returns obj[key]
  */

  function fetchArrayValues(obj, key) {
    let sKey = key,
      object = obj;

    sKey = sKey.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

    sKey = sKey.replace(/^\./, ''); // strip a leading dot

    const aKey = sKey.split('.');

    for (let i = 0, n = aKey.length; i < n; ++i) {
      const k = aKey[`${i}`]; // using string literal to safely parse the keys in an object - Fix codacy "Generic Object Injection Sink"

      if (k && object && typeof object ==='object' && k in object) {
        object = object[`${k}`]; // using string literal to safely parse the keys in an object - Fix codacy "Generic Object Injection Sink"
      } else {
        return null;
      }
    }

    return object;
  }

  /**
  * Validate custom attributes if it has nested object, if yes reject with an error or resolve.
  * @param {object} oCustomAttr
  */

  function validateCustomAttributes(oCustomAttr) {
    const pValidateCustomAttributes = new Promise((resolve, reject) => {
      if (!bSupportNestedObject && oCustomAttr) {
        let bValid = false;

        for (const key in oCustomAttr) {
          if (oCustomAttr[`${key}`] !== null && typeof oCustomAttr[`${key}`] === 'object') { // using string literal to safely parse the keys in an object - codacy "Generic Object Injection Sink"
            bValid = false;
            reject('Nested object is not supported for custom attributes');
          } else bValid = true;
        }
        if (bValid) resolve(bValid);
      } else {
        resolve(true);
      }
    });

    return pValidateCustomAttributes;
  }

  /**
  * Set the database if the data passed to the command is not null
  * if there is no messaging attribute in the data passed to the command, set the database with the data passed and resolve with the database object
  * if there is no messaging.customAttributes in the data passed to the command, set the database with the data passed and resolve with the database object
  * if there is messaging.customAttributes, validate custom attributes if it has nested object, if yes reject with an error or set the database with the data passed and resolve with the database object.
  * @param {object}
  * {messaging: { customAttributes: {}, ...(any free form data)} ...(any free form data)}
  *
  */

  Database.registerCommand('set', (e) => {
    if (!bDatabaseCleared) {
      if (isObjectAndNotNull(e.data)) {
        const { messaging } = e.data || {};

        const oDatabase = $$('database');

        if (isObjectAndNotNull(messaging)) {
          const { customAttributes } = messaging || {};

          if (isObjectAndNotNull(customAttributes)) {
            validateCustomAttributes(customAttributes).then(()=>{
              const oData = merge(oDatabase, e.data); /**shallow merge */

              $$('database', oData);

              Database.publish('updated', oData);

              e.resolve(oData);
            }).catch((error)=>{
              e.reject(error);
            });
          } else if (typeof customAttributes !=='object' || Array.isArray(customAttributes)) {
            e.reject('Custom attributes must be an object');
          } else {
            const oData = merge(oDatabase, e.data); /**shallow merge */

            $$('database', oData);

            Database.publish('updated', oData);

            e.resolve(oData);
          }
        } else if (typeof messaging !=='object' || Array.isArray(messaging)) {
          e.reject('Messaging property must be an object');
        } else {
          const oData = merge(oDatabase, e.data); /**shallow merge */

          $$('database', oData);

          Database.publish('updated', oData);

          e.resolve(oData);
        }
      } else {
        e.reject('Invalid option');
      }
    } else e.reject(CLEARED_REJECTION_MESSAGE);
  });

  /**
  * Set the database if the data passed to the command is not null
  * if there is no messaging attribute in the data passed to the command, update the database with the data passed and resolve with the database object
  * if there is no messaging.customAttributes in the data passed to the command, update the database with the data passed and resolve with the database object
  * if there is messaging.customAttributes, validate custom attributes if it has nested object, if yes reject with an error or update the database with the data passed and resolve with the database object.
  * @param {object}
  * {messaging: { customAttributes: {}, ...(any free form data)} ...(any free form data)}
  *
  */

  Database.registerCommand('update', (e) => {
    if (!bDatabaseCleared) {
      if (isObjectAndNotNull(e.data)) {
        const { messaging } = e.data || {};

        const oDatabase = $$('database');//get already stored database object from data model. at first time, it will be an empty object and it will be set with data passed to the command*/

        if (isObjectAndNotNull(messaging)) {
          const { customAttributes } = messaging || {};

          if (isObjectAndNotNull(customAttributes)) {
            validateCustomAttributes(customAttributes).then(()=>{
              const oData = merge(true, oDatabase, e.data); /**deep merge */

              $$('database', oData);

              Database.publish('updated', oData);

              e.resolve(oData);
            }).catch((error)=>{
              e.reject(error);
            });
          } else if (typeof customAttributes !=='object' || Array.isArray(customAttributes)) {
            e.reject('Custom attributes must be an object');
          } else {/**if no messaging.customAttributes attribute exists, resolve with the data passed to the command */
            const oData = merge(true, oDatabase, e.data); /**deep merge */

            $$('database', oData);

            Database.publish('updated', oData);

            e.resolve(oData);
          }
        } else if (typeof messaging !=='object' || Array.isArray(messaging)) {
          e.reject('Messaging property must be an object');
        } else {/**if no messaging attribute exists, resolve with the data passed to the command */
          const oData = merge(true, oDatabase, e.data); /**deep merge */

          $$('database', oData);

          Database.publish('updated', oData);

          e.resolve(oData);
        }
      } else {
        e.reject('Invalid option');
      }
    } else e.reject(CLEARED_REJECTION_MESSAGE);
  });

  /**
  * Get property from database and returns its value
  * @param {object}
  * {name: <<property_name>>}
  * property_name must be a string
  */

  Database.registerCommand('get', (e) => {
    const oDatabase = $$('database');

    if (!bDatabaseCleared) {
      if (isObjectAndNotNull(e.data)) {
        const { name } = e.data || '';

        if (name && typeof name === 'string') {
          const aProperties = name.split('.');/**if property name passed as property path, split by '.' */

          const oData = aProperties && aProperties.reduce((obj, key) =>{/**deep search for the property in a database object */
            if (obj && Object.prototype.hasOwnProperty.call(obj, key)) {
              return obj[`${key}`];
            } else {/**If not a direct property name, check if the property name passed is an array path with index and return the value*/
              return fetchArrayValues(obj, key);
            }
          }, oDatabase);

          if (oData!==null) e.resolve(oData);

          else e.reject('Property name does not exists');
        } else e.reject('Invalid option');
      } else {
        e.resolve(oDatabase);/**if no option is provided, return the entire database object*/
      }
    } else e.reject(CLEARED_REJECTION_MESSAGE);
  });

  /**
  * Remove property from database and updates the database
  * @param {object}
  * {name: <<property_name>>}
  * property_name must be a string
  */

  Database.registerCommand('remove', (e) => {
    const oDatabase = $$('database');

    if (!bDatabaseCleared) {
      if (isObjectAndNotNull(e.data)) {
        const { name } = e.data || '';

        if (name && typeof name === 'string') {
          const aProperties = name.split('.');/**if property name passed as property path, split by '.' */

          const oData = aProperties && aProperties.reduce((obj, key, index) =>{/**deep search for the property in a database object and remove the property */
            if (obj && Object.prototype.hasOwnProperty.call(obj, key)) {
              if (index === aProperties.length - 1) {
                delete obj[`${key}`];

                return oDatabase;
              } else return obj[`${key}`];
            } else { /**If not a direct property name, check if the property name passed is an array path with index and delete the property*/
              if (key.match(/\[(\w+)\]/g)) {
                let sKey = key;

                sKey = sKey.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
                sKey = sKey.replace(/^\./, ''); // strip a leading dot
                const aKey = sKey.split('.');

                if (index === aProperties.length - 1) {
                  if (Object.prototype.hasOwnProperty.call(obj, aKey[0]) && Array.isArray(obj[`${aKey[0]}`]) && aKey[1] < obj[`${aKey[0]}`].length) {
                    obj[`${aKey[0]}`].splice(aKey[1], 1);/**Remove the specific index from an array, if the property to remove is an array with specific index */

                    return oDatabase;
                  } else return null;
                } else {
                  return fetchArrayValues(obj, key);
                }
              } else return null;
            }
          }, oDatabase);

          if (oData!==null) {
            $$('database', oDatabase);

            Database.publish('removed', oDatabase);

            e.resolve();
          } else e.reject('Property name does not exists');
        } else e.reject('Invalid option');
      } else e.reject('Property name is mandatory');
    } else e.reject(CLEARED_REJECTION_MESSAGE);
  });

  /**
  * Clear all properties from database
  * @param {object}
  *
  */

  Database.registerCommand('clear', (e) => {
    if (e && e.commander && e.commander !== 'Messenger') {
      e.reject(`${e.commander} plugin does not have permission to access clear Database plugin command`);
    }

    bDatabaseCleared = true;
    Database.publish('cleared');

    e.resolve();
  });

  Database.registerCommand('configure', (e) => {
    if (!bDatabaseCleared) {
      const { enableNestedObject } = e.data;

      if (typeof enableNestedObject === 'boolean') bSupportNestedObject = enableNestedObject;

      e.resolve();
    } else e.reject(CLEARED_REJECTION_MESSAGE);
  });

  Database.ready();
});
